export const InputTypeEnum = {
  0: "Number",
  1: "Text",
  2: "Radio",
  3: "Checkbox",
  4: "Date",
  5: "Email",
  6: "Files",
  7: "Select",
  8: "Slider",
  9: "RichTextBox",
  10: "Table",
  11: "MultiInput",
};

export type InputTypeEnumKeys = keyof typeof InputTypeEnum;
